// Pure lookup helpers for the Knowledge Quality intelligence drawer.
import {
  FINDING_SEVERITY_TONE,
  FINDING_SEVERITY_RANK,
  KNOWLEDGE_STRENGTH_TEXT_TONE,
  PROGRESS_BAR_TONE,
  type FindingSeverity,
  type FindingSeverityTone,
  type KnowledgeEvidenceStrength,
  type ProgressBarTone,
} from "../constants";
import type { KQEvidence, KQFinding } from "./knowledgeQualityTypes";

export function severityTone(
  s: KQFinding["severity"] | string | null | undefined,
): FindingSeverityTone {
  const key = String(s ?? "INFO").toUpperCase() as FindingSeverity;
  return FINDING_SEVERITY_TONE[key] ?? FINDING_SEVERITY_TONE.INFO;
}

export function severityRank(s: KQFinding["severity"] | string): number {
  const key = String(s ?? "INFO").toUpperCase() as FindingSeverity;
  return FINDING_SEVERITY_RANK[key] ?? FINDING_SEVERITY_RANK.INFO;
}

export function evidenceStrengthTextTone(
  s: KQEvidence["evidence_strength"] | string | null | undefined,
): string {
  const key = String(s ?? "NONE").toUpperCase() as KnowledgeEvidenceStrength;
  return KNOWLEDGE_STRENGTH_TEXT_TONE[key] ?? "text-slate-400";
}

export function progressBarTone(tone: ProgressBarTone) {
  return PROGRESS_BAR_TONE[tone];
}

/** Sort key: gaps first (any non "STRONG_KNOWLEDGE"), then severity rank. */
export const STRONG_KNOWLEDGE_FINDING = "STRONG_KNOWLEDGE";
